import styled from "styled-components";
import { theme } from "../../theme";

export const Container = styled.div<{ $flex: any }>`
  display: flex;
  flex: ${({ $flex }) => $flex};
  justify-content: space-between;
  padding: 20px;
  flex-direction: column;
  background: white;
  border: 1px solid ${theme.colors.greyscale.gray20};
  border-radius: 6px;
  box-shadow: 0px 0px 12px 0px #00000014;
  height: 100%;
  width: 100%;
  /*
   * min-width: 0 — bu kutu bir flex çocuğu ve varsayılan min-width:auto ile
   * içeriğinin min-content genişliğinin altına inemiyor. 190px'lik iki select
   * yan yana durduğu için panel 390px'lik ekranda 686px'e şişip bütün sayfayı
   * yatay kaydırtıyordu.
   */
  min-width: 0;
`;

export const BoxTitle = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: ${theme.colors.greyscale.black};
`;

export const LastUpdate = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: ${theme.colors.greyscale.gray80};
  span {
    font-weight: 500;
  }
`;
